import { render, staticRenderFns } from "./imgSwiper.vue?vue&type=template&id=df5cd2c8&scoped=true"
import script from "./imgSwiper.vue?vue&type=script&lang=js"
export * from "./imgSwiper.vue?vue&type=script&lang=js"
import style0 from "./imgSwiper.vue?vue&type=style&index=0&id=df5cd2c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5cd2c8",
  null
  
)

export default component.exports